import { Route, Routes } from 'react-router';
import Home from './pages/home/Home';
import Signin from './pages/auth/Signin';
import Signup from './pages/auth/Signup';
import Product from './pages/product_details/Product';
import Shop from './pages/shop/Shop';
import Search from './pages/search/Search';
import Layout from './admin/pages/dashboard/Layout';
import { RefreshProvider } from './utils/RefreshProvider';
import Settings from './settings/Settings';
import { AuthProvider } from './utils/AuthContext';
import Checkout from './pages/checkout/Checkout';
import { AdminRoute } from './pages/auth/Protection';
import AccountSettings from './admin/pages/account/AccountSettings';

function App() {
  return (
    <AuthProvider>
      <RefreshProvider>
        <Routes>
          {/* Auth : */}
          <Route path='/signin' element={<Signin />} />
          <Route path='/signup' element={<Signup />} />

          {/* Public : */}
          <Route path='/' element={<Home />} />
          <Route path='/product/:slug' element={<Product />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:gender" element={<Shop />} />
          <Route path='/search' element={<Search />} />

          {/* User : */}
          <Route path="/account/*" element={<Settings />} />
          <Route path="/checkout" element={<Checkout />} />

          {/* Admin : */}
          <Route element={<AdminRoute />}>
            <Route path='/admin/settings' element={<AccountSettings />} />
            <Route path='/admin/*' element={<Layout />} />
          </Route>

        </Routes>
      </RefreshProvider>
    </AuthProvider>
  );
}

export default App;
